import { render, staticRenderFns } from "./ProductEditTranslatedNames.vue?vue&type=template&id=23581304"
import script from "./ProductEditTranslatedNames.vue?vue&type=script&lang=ts"
export * from "./ProductEditTranslatedNames.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23581304')) {
      api.createRecord('23581304', component.options)
    } else {
      api.reload('23581304', component.options)
    }
    module.hot.accept("./ProductEditTranslatedNames.vue?vue&type=template&id=23581304", function () {
      api.rerender('23581304', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/ProductEditTranslatedNames.vue"
export default component.exports